export default "__VITE_ASSET__Cx0SMVJ___"